import { Translations } from './en';

const fr: Translations = {
  draftLabel: 'Brouillon',
  formDraftsListTitle: 'Mes brouillons',
  formListTitle: 'Tous les formulaires',
  formTitle: 'Formulaire',
  formSubtitle: 'Choisissez un formulaire',
  chooseFormButton: 'Choisir dans la bibliothèque',
  addButton: 'Ajouter un formulaire',
  updatedOn: 'Modifié le {{date}}',
  entries_one: '{{count}} saisie',
  entries: '{{count}} saisies',
  selectedCount_one: '{{count}} formulaire sélectionné',
  selectedCount: '{{count}} formulaires sélectionnés',
};

export default fr;
